import { useLanguage } from '@/context/LanguageContext';
import translations from '@/utils/translations';

export default function Footer() {
  const { language } = useLanguage();
  const t = translations[language].footer;
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#5b6770] text-white py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div>
            <span className="text-lg font-heading tracking-tight text-[#ffa600]" >
              C.D. Brandt<span className="text-[#ffa600]">-</span>Lafuente
            </span>
            <p className="text-[#ffa600] text-sm mt-1">Carrer de Balmes, 421, 1º B - Barcelona</p>
          </div>
          <p className="text-[#ffa600] text-sm">
            &copy; {year} Cl&iacute;nica Dental Brandt-Lafuente. {t.rights}.
          </p>
        </div>
      </div>
    </footer>
  );
}
